import React from "react";
import loadable from "@loadable/component";
import { Route } from "react-router-dom";
import { PageLoader } from "GlobalComponent/PageLoader";
import { BS6_ENDPOINT } from "../constants";
import { page } from "GlobalEnum/Page";
import { Pages } from "GlobalEnum/NewPage";

const BS6Cars = loadable(
  () =>
    import(
      /* webpackChunkName: "bs6cars-desktop" */ "../containers/BS6CarsDesktop"
    ),
  {
    fallback: <PageLoader />,
  }
);

export const BS6CarsPageRoute = [
  <Route
    exact
    path={BS6_ENDPOINT}
    key="bs6-cars"
    render={props => (
      <BS6Cars
        pageId={page.BS6_CARS_DESKTOP.id}
        newPageId={Pages.BS6_CARS.id}
        {...props}
      />
    )}
  />,
];
